import React from "react";
import { default as MUIInputLabel } from "@mui/material/InputLabel";
import styled from "styled-components";

const StyledMUIInputLabel = styled(MUIInputLabel)`
  color: var(--colorTextPrimary) !important;
  font-family: var(--primaryTextFont) !important;

  input:hover {
    border-width: 2px !important;
  }

  input:focus {
    border-width: 2px !important;
    border-color: var(--primaryColor) !important;
  }
`;

export const InputLabel = (props) => {
  return <StyledMUIInputLabel {...props} />;
};
